import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import NewCollection from "./pages/NewCollection";
import Collections from "./pages/Collections";
import CollectionProfile from "./pages/CollectionProfile";
import MapPage from "./pages/MapPage";
import Reports from "./pages/Reports";
import Provenance from "./pages/Provenance";
import Settings from "./pages/Settings";
import Atlas from "./pages/Atlas";
import Drafts from "./pages/Drafts";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/atlas" element={<Atlas />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/collections/new" element={<NewCollection />} />
              <Route path="/collections" element={<Collections />} />
              <Route path="/collections/:id" element={<CollectionProfile />} />
              <Route path="/map" element={<MapPage />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/provenance" element={<Provenance />} />
              <Route path="/drafts" element={<Drafts />} />
              <Route path="/settings" element={<Settings />} />
            </Route>

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
